import * as React from "react";
import PropTypes from "prop-types";

// material-ui
import { makeStyles, useTheme } from "@mui/styles";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  Avatar,
  Box,
} from "@mui/material";
// style constant
const useStyles = makeStyles((theme) => ({
  sideIconCard: {
    "&.MuiCard-root": {
      position: "relative",
      borderRadius: "6px",
      boxShadow: "none !important",
    },
  },
  sideCardContent: {
    "&.MuiCardContent-root": {
      "&:last-child": {
        padding: "10px !important",
        [theme.breakpoints.down("sm")]: {
          padding: "0px !important",
        },
      },
    },
  },
  secondary: {
    "&.MuiTypography-root": {
      color: " #000",
      fontFamily: "Baloo Chettan 2",
      fontSize: "22px",
      fontStyle: "normal",
      fontWeight: " 600",
      lineHeight: "20px",
      // marginBottom: "20px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },
  },
}));

// =============================|| SIDE ICON CARD ||============================= //

export const SubTitle = ({ secondary }) => {
  const classes = useStyles();

  const theme = useTheme();
  const matchDownXs = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Card className={classes.sideIconCard}>
      <CardContent className={classes.sideCardContent}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6" className={classes.secondary}>
              <span>{secondary}</span>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

SubTitle.propTypes = {
  secondary: PropTypes.string,
};
